// import { createSelector } from 'reselect';

export const getErrMsg = state => state.getIn(['appointmentNotes', 'errMsg']);